// extracted by mini-css-extract-plugin
export default {"card":"card__NTcyY","hed":"hed__NmFlM","note":"note__MjQ4Y","link":"link__MzliO"};